import React from 'react';
import styled, {css} from 'styled-components'
import styles from './SpotifyPlaylist.module.css';

class SpotifyPlaylist extends React.Component {

  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    return  <iframe title="spotify embed" class={styles.spotifyembed} src={"https://open.spotify.com/embed/playlist/" + this.props.playlistid}
    width="300" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
  }
}

export default SpotifyPlaylist;
